
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#75aadb","d":"M0 0h36v24H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 9h36v6H0z"}}),_c('path',{attrs:{"d":"M0 10h36v4H0z"}})])
          )
        }
      }
    